import React from 'react';
import "./Privacy.scss";

function Privacy() {
    return (
        <div className="privacy">
            <div className="container-top">
                <div className="container">
                    <h1>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ и обработки персональных данных сервиса ООО «ЭКО-ФРИЗ»</h1>

                    <p>
                        Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и меры по
                        обеспечению безопасности персональных данных физических и юридических лиц, пользующихся услугами
                        Общества с ограниченной ответственностью «ЭКО-ФРИЗ» (далее — «Оператор») при заказе услуг по разработке
                        программного обеспечения (Telegram-ботов).
                    </p>

                    <ul className="__list">

                        <li className="title">1. ОБЩИЕ ПОЛОЖЕНИЯ</li>
                        <ul className="__sublist">
                            <li>
                                1.1. Настоящая Политика разработана в соответствии с Конституцией РФ, Федеральным законом от
                                27.07.2006 г. № 152-ФЗ «О персональных данных» и другими нормативными актами РФ.
                            </li>
                            <li>
                                1.2. Оператором персональных данных является ООО «ЭКО-ФРИЗ» (ИНН 1648051021,
                                КПП 164801001, адрес: 422545, РОССИЯ, Республика Татарстан, Зеленодольский р-н,
                                г. Зеленодольск, пр-кт Строителей, д. 24, кв. 117).
                            </li>
                            <li>
                                1.3. Использование сайта Оператора, его сервисов или оплата выставленных счетов означает
                                безоговорочное согласие Пользователя (Заказчика) с настоящей Политикой и указанными в ней
                                условиями обработки его персональной информации.
                            </li>
                            <li>
                                1.4. В случае несогласия с условиями Политики Пользователь должен воздержаться от использования услуг Оператора.
                            </li>
                        </ul>

                        <li className="title">2. СОСТАВ ОБРАБАТЫВАЕМЫХ ДАННЫХ</li>
                        <ul className="__sublist">
                            <li>Оператор может обрабатывать следующие категории данных Пользователя:</li>

                            <li>2.1. Данные для исполнения договора оказания IT-услуг:</li>
                            <ul className="__dot_list">
                                <li>Адрес электронной почты (E-mail);</li>
                                <li>Номер телефона;</li>
                                <li>Имя пользователя в мессенджере Telegram (Telegram ID/Username) для настройки разрабатываемого Программного обеспечения;</li>
                                <li>История заказов и согласованных Технических заданий.</li>
                            </ul>

                            <li>2.2. Технические данные (автоматический сбор):</li>
                            <ul className="__dot_list">
                                <li>IP-адрес и история посещений;</li>
                                <li>Данные об устройстве: модель, операционная система, разрешение экрана, часовой пояс;</li>
                                <li>Файлы Cookie (см. раздел 6).</li>
                            </ul>

                            <li>
                                2.3. Данные, получаемые при финансовых расчетах: В связи с тем, что оплата производится путем
                                безналичного перечисления на расчетный счет Оператора, мы обрабатываем только те сведения,
                                которые поступают от банка в банковской выписке:
                            </li>
                            <ul className="__dot_list">
                                <li>Сведения об отправителе: ФИО или наименование компании-плательщика.</li>
                                <li>Сведения о банке: Наименование кредитной организации, со счета которой произведен платеж.</li>
                                <li>Детали транзакции: Сумма операции, дата и время платежа.</li>
                                <li>Примечание: Оператор не осуществляет сбор и хранение номеров банковских карт (PAN) и кодов безопасности (CVC/CVV).</li>
                            </ul>
                        </ul>

                        <li className="title">3. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</li>
                        <ul className="__sublist">
                            <li>Оператор обрабатывает персональные данные в следующих целях:</li>

                            <ul className="__dot_list">
                                <li>3.1. Исполнение договора: Заключение и исполнение договора на разработку Telegram-бота, согласование Технического задания, передача доступов к Программному обеспечению Заказчику.</li>
                                <li>3.2. Соблюдение законодательства РФ: Бухгалтерский и налоговый учет, формирование и отправка кассовых чеков (фискализация) в соответствии с 54-ФЗ.</li>
                                <li>3.3. Клиентская поддержка: Обработка запросов, технических заданий и претензий Пользователя.</li>
                                <li>3.4. Аналитика: Улучшение качества работы сервиса, анализ обратной связи.</li>
                            </ul>
                        </ul>

                        <li className="title">4. ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ДАННЫХ</li>
                        <ul className="__sublist">
                            <li>
                                4.1. Обработка персональных данных осуществляется как автоматизированным, так и неавтоматизированным способами.
                            </li>
                            <li>
                                4.2. Сроки хранения:
                            </li>
                            <ul className="__dot_list">
                                <li>Данные о транзакциях, чеках и договорах хранятся в течение 5 (пяти) лет в соответствии с требованиями налогового и бухгалтерского законодательства РФ.</li>
                                <li>Технические данные и переписка хранятся в течение 1 (одного) года после сдачи проекта.</li>
                            </ul>

                            <li>4.3. Передача данных третьим лицам: Оператор вправе передавать персональные данные Пользователя следующим третьим лицам исключительно для целей исполнения Договора и требований закона:</li>
                            <ul className="__dot_list">
                                <li>Операторам фискальных данных (ОФД) и ФНС России — для передачи кассового чека (если применимо к физическим лицам).</li>
                                <li>Банкам (АО "АЛЬФА-БАНК" и др.) — для проведения безналичных расчетов и возвратов.</li>
                                <li>Хостинг-провайдерам — при развертывании разработанного Telegram-бота на серверах по поручению Заказчика.</li>
                                <li>Правоохранительным органам — исключительно по мотивированному запросу в порядке, предусмотренном законодательством РФ.</li>
                            </ul>
                        </ul>

                        <li className="title">5. МЕРЫ ПО ЗАЩИТЕ ИНФОРМАЦИИ</li>
                        <ul className="__sublist">
                            <li>
                                5.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты
                                персональных данных от неправомерного доступа, уничтожения, изменения, блокирования,
                                копирования и распространения.
                            </li>
                            <li>
                                5.2. Доступ к персональным данным (в т.ч. к исходным кодам и API-токенам ботов) имеют только сотрудники и разработчики Оператора, которым эта информация необходима для выполнения трудовых обязанностей и которые подписали обязательство о неразглашении (NDA).
                            </li>
                        </ul>

                        <li className="title">6. ИСПОЛЬЗОВАНИЕ ФАЙЛОВ COOKIE</li>
                        <ul className="__sublist">
                            <li>
                                6.1. Сайт Оператора может использовать файлы Cookie для:
                            </li>
                            <ul className="__dot_list">
                                <li>Аутентификации Пользователя и сохранения его сессии.</li>
                                <li>Сбора технической статистики для улучшения работы сайта.</li>
                            </ul>

                            <li>
                                6.2. Пользователь может отключить файлы Cookie в настройках своего браузера.
                            </li>
                            <li>
                                6.3. Оператор также может использовать сторонние сервисы веб-аналитики (Яндекс.Метрика и др.), которые собирают обезличенные данные о поведении посетителей сайта.
                            </li>
                        </ul>

                        <li className="title">7. ПРАВА ПОЛЬЗОВАТЕЛЯ</li>
                        <ul className="__sublist">
                            <li>Пользователь имеет право:</li>
                            <ul className="__dot_list">
                                <li>7.1. Получать информацию, касающуюся обработки его персональных данных.</li>
                                <li>7.2. Требовать уточнения своих персональных данных, их блокирования или уничтожения в случае, если данные являются неточными или устаревшими.</li>
                                <li>
                                    7.3. Отозвать согласие на обработку персональных данных.
                                    <br />
                                    Примечание: Отзыв согласия не влечет уничтожение данных, которые Оператор обязан хранить в силу закона (например, бухгалтерская отчетность по оплаченным договорам разработки).
                                </li>
                            </ul>
                        </ul>

                        <li className="title">8. КОНТАКТЫ И РЕКВИЗИТЫ</li>
                        <ul className="__sublist">
                            <li>
                                По всем вопросам, связанным с настоящей Политикой, Пользователь может обращаться к Оператору
                                по электронной почте: info@dit-company.ru.
                            </li>
                            <li>
                                Оператор: ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ЭКО-ФРИЗ"
                                ИНН: 1648051021 | КПП: 164801001
                                Юридический адрес: 422545, РОССИЯ, Республика Татарстан, г. Зеленодольск, пр-кт Строителей, д. 24, кв. 117
                                Банковские реквизиты: Р/с 40702810916960000190 в АО "АЛЬФА-БАНК", БИК 044525593
                            </li>
                            <li>Дата публикации актуального документа: 02.03.2026</li>
                        </ul>

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Privacy;